<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <section v-else>
      <img class="img" src="/static/images/Normal23/banner.jpg" />
      <div class="box">

        <!-- 首次查询 -->
        <template v-if="datas.scan_count <= 1">
          <h4>请核对标识上的身份码:</h4>
          <h4>六位数字是 <span class="red-txt" v-text="datas.verify"></span></h4>
          <h4>流向码正确 这是首次查询</h4>
        </template>

        <!-- 多次查询 -->
        <template v-else>
          <h4 class="red-txt">该流向码已被多次查询，谨防假冒。</h4>
          <h4 class="red-txt">请按照下方的“查询核查要点”，</h4>
          <h4 class="red-txt">如1、2项不一致的：请勿购买及举报！</h4>
          <h4>标签上的身份码6位数字是 <span class="red-txt" v-text="datas.verify"></span></h4>
          <h4>首次查询时间 <span v-text="datas.scan_first_time"></span></h4>
        </template>

        <h4 class="red-txt">本产品的流向信息为: </h4>
        <h4 v-if="datas.batch && datas.batch.name">批 次 号 : {{ datas.batch.name }}</h4>
        <h4>批发企业:</h4>
        <h4 v-text="datas.business.name"></h4>
        <h4>生产企业:</h4>
        <div v-for="(item, index) in datas.dealer" :key="index">
          <template v-if="index === 0">
            <h4>{{ item.name }}</h4>
          </template>
        </div>
        <h4>品　　种: <span v-text="datas.product.name"></span></h4>
        <h4>举报电话: 应急 12350 政府 12345</h4>

        <!-- <audio id="audioPlayer" v-if="audioSrc" controls :src="audioSrc" autoplay="autoplay">抱歉，您的浏览器不支持音频播报</audio> -->

        <div class="copyright mt20">
          <p>开发设计: OID煤矸石注册中心防伪</p>
          <p class="mt10"><a href="https://beian.miit.gov.cn/">浙ICP备2021035319号</a></p>
        </div>

        <h3 class="mt20 mb20 blue-txt">查询核查要点：</h3>
        <h4 class="red-txt">手指点按页面下拉，网页由lj.oid.plus提供域名</h4>
        <h4 class="blue-txt">1、信息查询结果显示的生产厂家名称与产品包装上的生产厂家名称一致；</h4>
        <h4 class="blue-txt">2、信息查询结果显示的身份码数字与经营流向标识上的身份码一致；</h4>
        <h4 class="blue-txt">3、每查询一次，显示的查询次数加1。</h4>
      </div>
    </section>
  </div>
</template>

<script>
let self;
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'Normal23',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data() {
    return {
      code: null,
      vcode: null,
      count: 2,
      msg: '',
      datas: null,
      hintTxt: null,
      audioSrc: '',
      Loading: {
        type: 1,
        txt: "数据请求中..."
      }
    }
  },
  created() {
    self = this;
    document.body.style.backgroundColor = "rgb(255, 255, 255)";

    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }
  },
  methods: {
    playAudio(msg){
      const audioSrc = this.GetServerUrl(1) + `getVoice?text=${msg}`;
      this.audioSrc = audioSrc;
      setTimeout(() => {
        audioPlayer.load();  // 加载音频文件
        audioPlayer.play();  // 播放音频
      });
    },
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }

          self.datas = datas;
          localStorage.setItem("wwm_seedDetail",JSON.stringify(datas));
          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {
          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
          datas.verify = response.data.meta.verify; //防伪码

          //激活自定义属性
          if (response.data.meta.activation_a) {
            datas.attribute = JSON.parse(response.data.meta.activation_a);
          }

          //发货自定义属性
          if (datas.dealer && datas.dealer.length) {
            datas.attribute = JSON.parse(datas.dealer[0].attribute);
          }

          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }
          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;
          self.datas = datas;

          //语音播报
          // if(self.datas.antifake_auto){
          //   try {
          //     const msg = `该流向码已被多次查询，谨防假冒。请按照下方的“查询核查要点”，如1、2项不一致的：请勿购买及举报，标签上的身份码6位数字是${datas.verify}，首次查询时间${datas.scan_first_time} 本产品的流向信息为，批发企业${datas.business.name}，${datas.product.introduce?'生产企业'+datas.product.introduce:''}，品种${datas.product.name}，举报电话: 应急 12350，政府 12345`
          //     self.playAudio(msg);
          //   } catch (error) {
          //     console.log(error);
          //   }
          // }

          localStorage.setItem("wwm_seedDetail",JSON.stringify(datas));
          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    }
  }
}
</script>

<style scoped lang="scss">
$margin: top, right, bottom, left;
@each $i in $margin {
  @for $j from 1 through 100 {
    $key: str-slice($i, 1, 1);

    .m#{$key}#{$j} {
      margin-#{$i}: $j + px !important;
    }
  }
}

.img{
  width: 100%;
  display: block;
}
.red-txt{
  color: red;
}
.blue-txt{
  color: #005da5;
}
.box{
  color: #333;
  padding: 20px;
  h4{
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 12px;
  }
}

.copyright{
  text-align: right;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/view/Normal23.vue